/**
 * Created by Bart Decorte
 * Date: 2019-09-24
 * Time: 13:46
 */

export default class CloneModuleModal {
  constructor() {
    this.$root = $('#modal-clone-module');
  }

  form() {
    return this.$root.find('form');
  }

  setTableId(tableId) {
    let action = this.form().data('action');
    action = action.replace('__table__', tableId);
    this.setAction(action);
  }

  setAction(action) {
    this.form().attr('action', action);
    return this;
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/modals/CloneModuleModal.js